module.exports = __webpack_public_path__ + "static/media/test5_4.46a11fe2.png";